import axios from '@js/clients/axios';

import { depatternize } from '@formatters/patternize';
import invalidateZIP from '@validators/zip';

import { VISIBLE_OPTIONS } from '@/components/Form/javascripts/options';

const ZIPS = {};

function zipEndpoint() {
  return 'zip_search';
}

export default function zipCode(parent, complete = false, endpoint = zipEndpoint) {
  function format(state = '', stateID = '', city = '', neighborhood = '', street = '') {
    return {
      [`${parent}[state]`]: state,
      [`${parent}[state_id]`]: stateID,
      [`${parent}[city]`]: city,
      [`${parent}[district]`]: neighborhood,
      [`${parent}[neighborhood]`]: neighborhood,
      [`${parent}[street]`]: street,
    };
  }

  function success(response) {
    const searching = depatternize(response.data.zip);

    ZIPS[searching] = [
      response.data.state,
      response.data.state_id,
      response.data.city,
      response.data.neighbourhood,
      response.data.street,
    ];

    return format(...ZIPS[searching]);
  }

  function failure(error) {
    /* eslint-disable no-console */
    console.log('ZIPS/SEARCH FAILURE');
    console.error(error);
    /* eslint-enable no-console */

    return format();
  }

  return function zipSearch(props, planter, name) {
    if (complete && !VISIBLE_OPTIONS.includes(planter.visibilities.value[`${parent}[city]`])) {
      return {};
    }

    const searching = depatternize(planter.values.value[name]);

    if (!searching || invalidateZIP(searching)) {
      return {};
    }

    if (ZIPS[searching]) {
      return format(...ZIPS[searching]);
    }

    try {
      const address = parent
        .split('[')
        .map((i) => i.replace(']', ''))
        .reduce((reduced, i) => reduced[i], planter.entity.value);

      if (searching === depatternize(address.zip_code) && address.street) {
        ZIPS[searching] = [
          address.state,
          address.state_id,
          address.city,
          address.neighborhood,
          address.street,
        ];

        return format(...ZIPS[searching]);
      }
    } catch (err) { /* */ }

    const loading = Object.keys(format());
    loading.push(`${parent}[zip_code]`);

    const zip = planter.values.value[name];

    return {
      loading,
      promise: axios
        .get(endpoint(zip), { params: { zip } })
        .then(success)
        .catch(failure),
    };
  };
}
